export const apiPath = {
  login: "/login",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  verifyOtp: "/verify-otp",
  logout: "/logout",
  getInterviewLocations: "/get-interview-location-list",
  getCountryCodes: "/get-countries",

  //employer
  getEmployerList: "/get-employer-list",
  getEmployerJobofferList: "/get-employer-job-offer-list",
  employerSpokenLanguage: "/get-employer-spoken-language",
  employerNationality: "/get-employer-nationalities",
  employerSpecialCourses: "/get-employer-special-course",
  empoyerContractStatus: "/get-employer-contract-status",
  employerCooking: "/get-employer-cooking-list",
  shareLinkEmployer: "/share-link-employer",
  employerEducation: "/get-education",
  employerMainSkills: "/get-main-skills",
  employerCookingList: "/get-cooking-list",
  employerLocationList: "/get-location-list",
  employerMaritalStatus: "/get-marital-status",
  addEmployer: "/save-employer",
  updateEmpDetails: "/update-employer",
  getEmployerDetails: "/get-employer-detail",

  //job offer
  getFlexibleDate: "/get-flexible-date",
  getDayOffList: "/get-day-off-list",
  getPets: "/get-pets",
  getExpectedSalary: "/get-expected-salary",
  getLanguage: "/get-language",
  addJobOffer: "/add-job-offer",
  getJobofferList: "/get-job-list",
  getJobDetails: "/get-job-detail",
  cancelSuggestion: "/cancel-suggestion",
  sendExtendOffer: "/send-extend-offer",
  findWorker: "/find-worker",
  addNewSuggestWorker: "/suggest-worker",
  jobActivityLogList: "/job-activity-log-list",
  getJobWorkerList: "/get-job-worker-list",
  updateJobOfferStatus: "/change-job-offer-status",
  addNewJobOffer: "/save-job-offer",
  updateJobOffer: "/update-job-offer",
  getAgeListForjob: "/get-age-list",
  getJobStages: "/get-stage-list",
  getInterviewDayList: "/interview-day-list",
  getDuplicateJobs: "/global/get-duplicate-jobs",
  workerJobEncriptedID: "/get-worker-job-link",
  //worker
  getWorkerRoles: "/get-worker-role",
  getWorkerDetail: "/get-worker-detail",
  getRestrictedKey: "/get-restricted-Key",
  getWorkerReferenceIdInitials: "/get-worker-reference-id-initials",
  shareLinkWorker: "/share-link-worker",
  shareLinkWhatsappList: "/get-whatsapp-country-codes",
  getWorkerStatus: "/get-worker-statuses",
  addWorker: "/add-worker",
  editPartnerWorkerBioData: "/edit-partner-worker-biodata",
  getPartnerWorkerStatus: "/partner-get-worker-statuses",
  partnerWorkerChangeStatus: "/partner-worker-change-status",
  partnerWorkerList: "/partner-worker-list",
  partnerWorkerProfileStatuses: "/partner-worker-profile-statuses",
  partnerSendRegLink: "/partner-send-registration-link",
  saveWorkerProcessingData: "/save-worker-processing-data",
  getWorkersList: "/get-worker-list",
  getInviteWorkersList: "/invite-worker-list",
  getpt_ts: "/get-ptts",
  getAgelist: "/get-age-list",
  worker_duties: "/get-worker-duties-list",
  employer_duties: "/get-worker-duties-list",
  workerCurrentLocation: "/get-worker-location-list",
  workerNationality: "/get-worker-nationalities",
  workerContractStatus: "/get-worker-contract-status",
  workerLanguages: "/get-worker-spoken-language",
  workerHeightMeasurement: "/get-height",
  workerHoroscope: "/get-horoscope",
  workerChineseHoroscope: "/get-chinese-horoscope",
  workerWeightMeasurement: "",
  workerReligion: "/get-worker-religion",
  workerMaritalStatus: "/get-worker-marital-status",
  workerChildrenCount: "",
  workerNoOfSiblings: "",
  WorkerExperience: "/get-work-experience-list",
  workerEducation: "/get-worker-education",
  workerSpecialCourses: "/get-worker-special-course",
  workerMainSkills: "/get-worker-main-skills",
  workerCooking: "/get-worker-cooking-list",
  workerLeavingReason: "/get-leaving-reason-list",
  getTerminationReason: "/terminated-reason-list",
  shiftExperience: "/shift-experience",
  workerJobStatus: "/worker-job-status",
  workerCountry: "/get-countries",
  workerDistrict: "/get-worker-district",
  workerMonths: "/get-worker-month",
  workerRole: "/get-worker-role",
  workerGender: "/get-gender-list",
  getSignedUrl: "/get-signed-url",
  getMultiSignedUrl: "/get-multi-signed-url",
  removeBg: "/remove-bg",
  convertToPdf: "/convert-to-pdf",
  uploadVideo: "/update-video",
  getWorkerInfo: "/get-worker-detail",
  getWorkerJobs: "/worker-job-list",
  inviteWorker: "/invite-worker",
  changeWorkerStatus: "/change-worker-status",
  updateWorker: "/update-worker",
  updateWorkerExp: "/update-worker-work-experience",
  getEmployerJobappliedWorkersList: "/get-employer-job-applied-worker-list",
  saveWorkerBiodata: "/save-worker-biodata",
  saveWorkerBasicProfilePath: "/save-worker-basic-details",
  saveWorkerConsulate: "/save-worker-consulate-details",
  saveWorkerPassportDetails: "/save-worker-passport-details",
  saveWorkerOverseasDetail: "/save-worker-overseas-detail",
  assignPTWorker: "/assign-pt-to-worker",
  getWorkerValidateStatus: "/get-worker-validate-status",
  getWorkerActivityLog: "/worker-activity-log-list",
  saveWorkerValidateStatus: "/worker-validate-details",
  updateWorkerProfileImage: "/update-profile-image",
  partnerWorkerUpdateProfileImg: "/partner-worker-update-profile-image",
  uploadIndoDocumentAfterPTAssign: "/upload-indonesian-document-after-pt-assign",
  deleteWorkerIndonesianDocumentPath: "/delete-indonesian-document",
  getJobStatusList: "/get-job-statuses",
  getWorkerProfileStatus: "/get-worker-profile-statuses",
  updateWorkerDetails: "/update-worker-details",
  workerRefrenceIdInitals: "/get-worker-reference-id-initials",
  getWorkerCanStartDate: "get-worker-can-start-date",
  removeBackground: "/remove-bg",
  removeBackgroundFromURL: "/remove-bg-from-url",
  getInterviewCounts: "/get-interview-counts",
  //worker Address
  addAddress: "/add-worker-address",
  getAddress: "/get-worker-previous-address",
  updateAddress: "/update-worker-address",
  setAddress: "/address-set-default",
  deleteAddress: "/delete-address",
  //Employer Address
  addEmployerAddress: "/add-employer-address",
  getEmployerAddress: "/get-employer-previous-address",
  updateEmployerAddress: "/update-employer-address",
  setEmployerAddress: "/set-employer-address-default",
  deleteEmployerAddress: "/delete-employer-address",
  //contract
  getAgencyList: "/nationality-agency-list",
  getItemTypeList: "/price-item-type-list",
  getItemDescriptionAndPrice: "/item-price-list",
  getcontractCategory: "/contract/invoices/contract-category-list",
  createContract: "/add-contract",
  getContractInvoiceDetails: "/get-contract-invoice-detail",
  getContractDetails: "/get-contract-detail",
  addPayment: "/add-payment",
  getInvoiceList: "/invoice-list",
  getInvoiceStatus: "/invoice-status-list",
  getContractList: "/contract-list",
  approvePayment: "/approve-payment",
  voidPayment: "/void-payment",
  //Invoices
  invoices: "/employer-contract-invoice-list",
  invoicesFixedItemList: "/contract/invoices/fixed-item-list",
  invoicesGetBasePrice: "/contract/invoices/base-price",
  promotionListByWorker: "/contract/invoices/promotion-list-by-worker",
  getCalculatePrice: "/contract/invoices/calculate-price",
  setContractInvoice: "/contract/invoices/add",
  invoicesList: "/contract/invoices/list",
  invoiceStatus: "/contract/invoices/status-list",
  invoiceDetails: "/contract/invoices/detail",
  contractGLobalStatusList: "/contract/global/status-list",
  invoiceActivityLogList: "/contract/invoices/activity-log-list",
  updatePaymentInvoice: "/contract/invoices/add-payment",
  reservationFee: "/contract/invoices/get-reservation-fee",
  invoiceRemarks: "/contract/invoices/remarks-list",
  addEditInvoiceRemarks: "/contract/invoices/save-remarks",
  deleteInvoiceRemarks: "/contract/invoices/delete-remarks",
  saveUploadInvoicePaymentAttachment: "/contract/invoices/upload-payment-attachment",
  getActionStatusList: "/contract/invoices/get-action-list",
  changeInvoiceStatus: "/contract/invoices/change-status",
  invoiceGLobalCancellationReason: "/contract/global/cancellation-reason-list",
  refundInvoice: "/contract/invoices/add-refund",
  addInvoiceExchange: "/contract/invoices/add-exchange",
  updateAdjustAmount: "/contract/invoices/adjust-amount",
  getContracts: "/contract/global/list",
  getContractInvoiceStatus: "/contract/global/status-list",
  getPolicies: "/contract/invoices/fixed-item-list-by-type",
  saveInsurance: "/add",
  getInsuranceDetails: "/details",
  getInsuranceList: "/list",
  getInsuranceActivityLog: "/activity-log-list",
  saveInsuranceActivated: "/activate",
  updateInsuranceData: "/update",
  updateInsuranceStatusApi: "/update-status",
  getPoliciesEndorsmentList: "/endorsement-type-list",
  checkPolicyNumber: "/duplicate-policy-number-check",
  saveInsuranceEndorsement: "/add-endorsement",
  updatePaymentFollowUp: "/contract/invoices/update-payment-follow-up",
  updateStatusEndorsement: "/update-endorsement-status",
  getInsuranceRemarks: "/remarks-list",
  addEditInsuranceRemarks: "/save-remarks",
  removeInsuranceRemarks: "/delete-remarks",
  getInsuranceStatusList: "/status-list",
  createWorker: "/save-worker",
  saveGeneralInvoice: "/contract/invoices/add-individual",
  saveInsuranceInvoice: "/contract/invoices/add-insurance-invoice",
  saveWorkerJobOfferAcceptInterview: "/accept-interview",
  saveWorkerJobOfferCancelInterview: "/cancel-interview",
  saveWorkerManageSuggestedJob: "/manage-suggested-job",
  updateContractWorker: "/contract/invoices/save-worker",
  getWorkerOnboarding: "/settings/worker/search-onboarding-staff",
  updateWorkerOnboardingStaff: "/settings/worker/change-onboarding",
  getDuplicateWorkerCount: "/global/get-duplicate-workers-count",
  getDuplicateWorkers: "/global/get-duplicate-workers",
  serachStaffInterpreter: "/settings/worker/search-interpreter-staff",
  changeInterpreter: "/settings/worker/change-interpreter",
  getWorkerPreviousPhoto: "/global/get-worker-previous-images",
  chatvalidateChangeUserGroupCsInterpreter: "/chats/validate-change-user-group-cs-interpreter",
  qrBranchGenerateCode: "/settings/branch/generate-qr",
  qrBranchReGenerateCode: "/settings/branch/regenerate-qr",
  //CS
  staffRoleList: "/staff-role-list",
  addCS: "/add-staff",
  staffList: "/get-staff-list",
  addPromotion: "/add-promotion",
  getPromotionList: "/promotion-list",
  getContractPromotionList: "/contract-promotion-list",
  updatePromotion: "/update-promotion",
  savePermission: "/save-permissions",
  getStaffPermissions: "/get-staff-permissions",
  saveNewItemType: "/add-item-type",
  getPriceItemTypeList: "/price-item-type-list",
  saveNewItemTypePrice: "/add-item-price",
  editItemTypePrice: "/edit-item-price",
  addNewCode: "/add-conditional-item-code",
  getConditionalItemCodeList: "/get-conditional-item-code-list",
  addConditionalListItem: "/add-conditional-item",
  getConditionalItemList: "/get-conditional-item-list",
  updateConditionalItem: "/update-conditional-item",
  changeStaffStatus: "/change-staff-status",
  getStaffDetails: "/get-staff-detail",
  updateStaff: "/update-staff",
  updateStaffPassword: "/change-staff-password",

  // pricelist
  invoicePromotionList: '/contract/invoices/promotion-list',
  invoiceConditionalItemDirectHire: '/contract/invoices/conditional-item-direct-hire-list',
  invoiceConditionalItemLocal: '/contract/invoices/conditional-item-local-list',
  invoiceConditionalItemOverseas: '/contract/invoices/conditional-item-overseas-list',
  invoiceConditionalItemOverseasSave: '/contract/invoices/conditional-item-overseas-save',
  fixedItemList: '/contract/invoices/fixed-item-list',
  fixedItemListByType: '/contract/invoices/fixed-item-list-by-type',
  fixedItemSave: '/contract/invoices/fixed-item-save',
  invoiceWorkerPromotionList: '/contract/invoices/worker-promotion-list',
  promotionSave: '/contract/invoices/promotion-save',
  invoiceConditionalItemDirectHireSave: '/contract/invoices/conditional-item-direct-hire-save',
  invoiceConditionalItemLocalSave: '/contract/invoices/conditional-item-local-save',
  workerPromotionSave: '/contract/invoices/worker-promotion-save',

  // Interview
  getScheduledInterview: "/upcoming-interviews",
  getInterviewTimeSlots: "/get-interview-slots",
  getInterviewDateSlots: "/get-interview-date-slots",
  confirmScheduledInterview: "/schedule-interview",
  getInterviewDetails: "/job-worker-interview-detail",
  updateInstantInterviewStatus: "/update-instant-interview-status",
  getUpcomingINterviews: "/upcoming-interviews",
  markInterviewCompleted: "/mark-interview-completed",
  getInterviewsToBeCompleted: "/get-interviews-to-be-completed",
  getNewInterviewDetails: "/interview-detail/",
  generateInstantInterview: "/create-instant-interview",
  rescheduleInterview: "/reschedule-interview",
  cancelInterview: "/cancel-interview",
  manageInterviewStatus: "/manage-interview-status",
  cancelInvite: "/cancel-invite",
  unArchiveJobStage: "/unarchived-job-stage",
  declineInterviewSchedule: "/change-job-stage",

  //newly created endpoints
  agencies: "/settings/agency/list",
  mappingAgencies: "/settings/agency/mapping-list",
  activeAgencies: "/settings/agency/active-agency-list",
  employerRemarks: "/get-employer-remarks-list",
  addEmployerRemarks: "/save-employer-remarks",
  deleteEmployerRemarks: "/delete-employer-remarks",
  workeremarks: "/get-worker-remarks-list",
  addWorkerRemarks: "/save-worker-remarks",
  deleteWorkerRemarks: "/delete-worker-remarks",
  processingRemarks: "/get-processing-remarks-list",
  addProcessingRemarks: "/save-processing-remarks",
  deleteProcessingRemarks: "/delete-processing-remarks",
  employerContracts: "/employer-contract-list",
  contractDetails: "/contract/global/details/",
  deleteAgency: "/settings/agency/delete",
  addAgency: "/settings/agency/add",
  viewAgency: "/settings/agency/view/",
  updateAgency: "/settings/agency/update",
  branches: "/settings/branch/list",
  getBranchesByPartnerStaffId: "/settings/branch/list-by-partner",
  mappingBranches: "/settings/branch/mapping-list",
  activeBranches: "/settings/branch/active-branch-list",
  addBranch: "/settings/branch/add",
  viewBranch: "/settings/branch/view/",
  updateBranch: "/settings/branch/update",
  getBranchesByAgencyId: "settings/branch/list-by-agency",
  countries: "/get-countries",
  locations: "/get-work-location-list",
  roles: "/settings/roles/list",
  deleteRole: "/settings/roles/delete",
  addRole: "/settings/roles/add",
  addDetailsPolicy: "/settings/leave-policy/add",
  viewRole: "/settings/roles/view/",
  updateRole: "/settings/roles/update",
  emoloyerJobOffers: "/get-employer-job-offer-list",
  jobOfferDetail: "/get-employer-job-offer-list",
  getJobStatus: "/get-job-statuses",
  jobOfferworkers: "/get-job-worker-list",
  viewEmployer: "/get-employer-detail",
  uploadProcessingFiles: "/upload-processing-files",
  getProcessings: "/processing/global/list",
  getProcessingFiles: "/get-processing-file-list",
  getProcessingSatusList: "/get-processing-status-list",
  getProcessingGlobalSatusList: "/processing/global/status-list",
  updateProcessingGlobalSatusList: "/processing/global/status-update",
  updateProcessingStatus: "/update-processing-status",
  updateProcessingDetails: "processing/global/details-update",
  deleteProcessingFile: "/delete-processing-files",
  getProcessingLicence: "/get-processing-licence-list",
  getInsuranceTypeList: "/get-insurance-type-list",
  getProcessingDetails: "/get-processing-details",
  updateProcessingDocuments: "/update-processing-documents",
  updateProcessingFullDetails: "/update-processing-full-details",
  updateProcessingVisaEVisa: "/update-processing-visa-evisa",
  processingActivityLogList: "/processing-activity-log-list",
  medicalDocumentSave: "/processing/medical/documents-save",
  medicalDocumentDelete: "/processing/medical/document-file-delete",
  medicalDocumentView: "/processing/medical/documents-details/",
  medicalDocumentStatusList: "/processing/medical/document-status-list/",
  medicalDocumentStatusChange: "/processing/medical/document-status-change",
  visaDocumentDetails: "/get-processing-visa-document-details/",
  insuranceDocumentStatusList: "/processing/insurance/document-status-list/",
  insuranceDocumentStatusChange: "/processing/insurance/document-status-change",
  eVisaDocumentStatusChange: "/update-processing-visa-status",
  insuranceDocumentSave: "/processing/insurance/document-save",
  insuranceDocumentView: "/processing/insurance/documents-details/",
  updateMasterForm: "/pdf/form/master-update",
  getMasterFormDetails: "/pdf/form/get-master-details/",
  getProfileDetails: "/pdf/form/get-profile-details/",
  getLastPullDetails: "/pdf/form/get-last-pull-details/",
  processingFollowUpList: "/processing/follow-up/view/",
  saveFollowUp: "/processing/follow-up/save",
  deleteFollowUp: "/processing/follow-up/delete",
  preDepartureUploadMedFile: "/processing/predeparture/upload-medical-file",
  medicalDocStatusList: "/processing/predeparture/medical-document-status-list/",
  medicalDocStatusChange: "/processing/predeparture/medical-document-status-change",
  medicalDocumentFileDelete: "/processing/predeparture/medical-document-file-delete",
  preDepartureOtherDocStatus: "/processing/predeparture/other-document-status-list/",
  getEvisaDocumentStatusList: "/get-processing-visa-status-list/",
  preDepartureOtherDocChangeStatus: "/processing/predeparture/other-document-status-change",
  visaShareUpdate: "/processing/global/visa-share-update",
  medicalShareUpdate: "/processing/predeparture/medical-share-update",
  deploymentDocumentShareUpdate: "/processing/deployment/document-share-update",
  preDepartureDocumentView: "/processing/predeparture/documents-details/",
  medicalClinicList: "/settings/medical-clinic/list",
  promptManagerClinicList: "/settings/prompt-manager/list",
  saveMedicalClinic: "/settings/medical-clinic/save",
  viewMedicalClinic: "/settings/medical-clinic/view/",
  deploymentDocumentView: "/processing/deployment/documents-details/",
  deploymentUpdateDHLContract: "/processing/deployment/update-dhl-contract",
  deploymentUpdateFlightDetails: "/processing/deployment/update-flight-details",
  deploymentUpdateHKIDDetails: "/processing/deployment/update-hkid-details",
  deploymentUpdatePickupDetails: "/processing/deployment/update-pickup-details",
  deploymentStatusList: "/processing/deployment/document-status-list",
  deploymentChangeStatus: "/processing/deployment/document-status-change",
  updateProcessingVisaAuth: "/update-processing-visa-authorization",
  activateProcessing: "/processing/global/activate-processing",
  activateProcessingGroup1And2: "/processing/global/activate-processing-for-group-one-two",
  changeProcessingCs: "/processing/global/change-processing-cs",
  update988b: "/pdf/form/988b-update",
  update988a: "/pdf/form/988a-update",
  update407: "/pdf/form/407-update",
  downloadEditablePdf: "/pdf/document/download-editable-pdf-file",
  downloadNonEditablePdf: "/pdf/document/download-non-editable-pdf-file",
  addEmpAddress: "/add-employer-address",
  updateEmpAddress: "/update-employer-address",
  addEmpCurrentWorker: "/add-employer-worker",
  updateEmpCurrentWorker: "/update-employer-worker",
  employerAddressList: "/get-employer-address-list",
  deleteEmpAddress: "/delete-employer-address",
  setEmpPrimaryAddress: "/set-employer-primary-address",
  sendOtp: "/send-otp",

  employerWorkerList: "/get-employer-worker-list",
  employerWorkerDelete: "/delete-employer-worker",
  setEmpPrimaryWorker: "/set-employer-current-worker",
  nationalities: "/get-nationalities",
  genderList: "/get-gender-list",
  spokenLanguage: "/get-spoken-language",
  notificationList: "/hrms/notification/list",
  notificationUnreadCount: "/hrms/notification/get-unread-count",
  NotificationMarkUnread: "/hrms/notification/mark-unread",
  getMaritalStatus: "/get-marital-status",
  timeZoneList: "/timezone-list",
  getNumberCounter: "/get-number-counter",
  getChildCareAgeList: "/get-child-care-age-list",
  getChildCareDuties: "/get-child-care-duties",
  getElderlyCareDuties: "/get-elderly-care-duties",
  getHouseHoldChores: "/get-household-chores",
  getReligionList: "/get-religion",
  getContractStatus: "/get-contract-status",
  getMainSkills: "/get-main-skills",
  getCookingList: "/get-cooking-list",
  getPetList: "/get-pet-list",
  getCourseList: "/get-special-course",
  getEducationList: "/get-education",
  getAccommodation: "/get-accommodation",
  employerDistrict: "/get-district",
  getDistrictByCountryCode: "/get-district-by-country-code",
  saveEmpFamilyInfo: "/save-employer-family-info",
  updateEmployerBasic: "/update-employer-basic",
  updateEmployerBanStatus: "/update-employer-ban-status",
  employerActivityLog: "/employer-activity-log-list",
  updateContactDetail: "/update-contact-details",
  setPrimaryContact: "/set-primary-mobile",
  getDuplicateEmployerCount: "/global/get-duplicate-employers-count",
  getDuplicatesEmployer: "/global/get-duplicate-employers",
  getDuplicatesJobsCount: "/global/get-duplicate-jobs-count",


  users: "/get-staff-list",
  addUser: "/add-staff",
  updateUser: "/update-staff",
  changePassword: "/settings/users/users-creds-mail-send",
  viewUser: "/get-staff-detail",
  doops: "/settings/doop/list",
  addDoop: "/settings/doop/add",
  viewDoop: "/settings/doop/view/",
  updateDoop: "/settings/doop/update",
  getFeedbackList: "/settings/feedback/list",
  getInterviewList: "/get-interview-list",
  reportOfJobOfferList: "/hrms/reports/job-offer-list",
  reportOfInsuranceList: "/hrms/reports/insurance-list",
  reportOfContractList: "/hrms/reports/contract-list",
  jobOfferCreatedByList: "/hrms/reports/job-offer-created-by-list",
  calendar: "/hrms/calendar/list",
  viewalendarTask: "/hrms/task/view/",
  createCalendarTask: "/hrms/task/save",
  deleteCalendarTask: "/hrms/task/delete",
  userPermissions: "/settings/permission/list",
  permissionsWithoutStaff: "/settings/permission/list-without-staff",
  saveUserPermissionsMapping: "/settings/permission/map/save",
  holidays: "/settings/holiday/list",
  holidayListByStatus: "/settings/holiday/list-by-status",
  officialHolidays: "/holidays",
  policies: "/settings/leave-policy/list",
  detailPolicies: "/settings/leave-policy/list",
  addLeavePolicy: "settings/leave-policy/add",
  viewLeaveMaster: "/settings/leave-master/view/",
  addMasterLeavePolicy: "settings/leave-master/add",
  updateMasterLeavePolicy: "settings/leave-master/update",
  updateLeavePolicy: "/settings/leave-policy/update",
  leavePolicyMasterList: "/settings/leave-master/list",
  addHoliday: "/settings/holiday/add",
  manualUpdateLeave: "/hrms/leave-apply/manual-update",
  viewHoliday: "/settings/holiday/view/",
  updateHoliday: "/settings/holiday/update",
  shiftCodes: "/settings/shift-codes/list",
  addShiftCode: "/settings/shift-codes/add",
  uploadShiftCode: "/settings/shift-codes/roster-upload",
  updateShiftCode: "/settings/shift-codes/update",
  viewShiftCode: "/settings/shift-codes/view/",
  leaves: "/hrms/leave-apply/list",
  addLeave: "/hrms/leave-apply/add",
  eligibilityCheck: "/hrms/leave-apply/eligibility-check",
  updateLeave: "/hrms/leave-apply/update",
  leaveTypeList: "/hrms/leave-apply/type-list",
  leaveBalance: "/hrms/leave-apply/get-leave-balance/",
  viewLeave: "hrms/leave-apply/view/",
  withdrawLeave: "hrms/leave-apply/withdraw/",
  reporteesLeaves: "hrms/leave-apply/reportees-leave-list",
  reporteesLeaveStatusChange: "hrms/leave-apply/reportees-leave-status-change",
  reporteesIndividualLeaveStatusChange:
    "hrms/leave-apply/individual-reportees-leave-status-change",
  userSessionHistory: "hrms/reports/session-history",

  updateEmployerCS: "/update-employer-cs",
  searchStaffList: "/search-staff",
  searchPartnerStaff: "/settings/worker/search-partner-staff",
  changeCsStaff: "/settings/employer/change-cs-staff",
  searchCsStaff: "/settings/employer/search-cs-staff",
  getOtherCsStaff: "/settings/employer/search-other-cs-staff",
  updateInvoiceInsuranceCsStaff: "/settings/employer/change-other-cs-staff",

  profile: "/hrms/profile/details",
  updateProfile: "/hrms/profile/update",
  timeRequests: "/hrms/time-request/list",
  viewTimeRequests: "/hrms/time-request/view/",
  withdrawTimeRequests: "/hrms/time-request/withdrawn",
  addTimeRequests: "/hrms/time-request/add",
  updateTimeRequests: "/hrms/time-request/update",
  reportLeaveHistory: "/hrms/reports/leave-history",
  scheduleComplianceList: "/hrms/reports/schedule-compliance",
  reporteesTimeRequestList: "/hrms/time-request/reportees-list",
  reporteesTimeRequestAction: "/hrms/time-request/reportees-action",
  ledger: "/hrms/leave-apply/history-list",
  branchUsers: "/hrms/calendar/users-list",
  activeUsers: "/settings/users/active-list",
  activePermissionUsers: "/settings/users/active-permission-list",
  permissionsList: "/settings/permission/list",
  ownerOnboardingList: "/settings/permission/get-cs-interpreter-onboarding-details",
  savePermissions: "/settings/permission/save",
  permissionMapByUser: "/settings/permission/map/list",
  reportTimeRequest: "hrms/reports/time-request",
  reportTimeEntry: "/hrms/reports/time-entry",
  timeCreditList: "/hrms/reports/time-request",
  managerApprovedTimeRequest: "hrms/time-request/manager-list",
  viewManagerApprovedTimeRequest: "hrms/time-request/manager/view/",
  addManagerApprovedTimeRequest: "hrms/time-request/manager-add",
  deleteManagerApprovedRequestById: "hrms/time-request/manager/delete",
  viewManagerApprovedTimeRequests: "hrms/time-request/manager/view/",

  getAllSentMessages: "chat/get-sent-message/",
  getAllReceivedMessages: "chat/get-received-message/",
  initConversation: "chats/create-conversation",
  getChatMessageList: "chats/message-list",
  getAllConversactionList: "chats/conversation-list",
  getConversactions: "chats/conversactions",
  getChatHistoryList: "chats/chat-history-list",
  getS3signedUrl: "signed-url",
  createGroupConversationChat: "chats/create-conversation-group",
  addWhatsappWelcomeMessage: "whatsapp/send-welcome-message",
  getConversactionsHistory: "chats/get-conversactions-history",
  getConversactionListAll: "chats/conversation-list-all",
  getTotalUnreadMessageCount: "chats/unread-message-count",
  saveTranslationLanguageChat: "global/save-language-translate",
  getTranslationLanguageChat: "global/get-language-translate",

  //templates
  getTemplates: "settings/template/list",
  getModuleList: "settings/template/module-list",
  getCategoryList: "settings/template/category-list",
  getLanguageList: "settings/template/language-list",
  getDynamicFieldList: "settings/template/dynamic-field-list",
  addTemplate: "settings/template/add",
  getTemplateDetails: "settings/template/view/",
  updateTemplate: "settings/template/update",
  deleteTemplate: "settings/template/delete",
  getTemplateNameByFilter: "settings/template/name-list-by-module-category",
  sendTemplate: "settings/template/send-message",
  sendTemplateMessagePTAssign: "chats/send-template-message-assign-partner",
  sendChatMessageAPI: "chats/send-template-message",
  sendActionRequiredLogs: "chats/add-action-required",
  getActionRequiredLogsList: "chats/get-action-list",
  getTemplateWhatsApp: "chats/get-template-list-whatsapp",
  sentWhatsAppTemplateMessage: "chats/send-whatsapp-template-message",
  //initConversation: "/create-conversation",

  //prompt manager
  promptsManager: "/prompts/",
  aiGenerateContent: "/ai/generate-content",
  aiReGenerateContent: "/ai/regenerate-content",
};
// export const API_URL = "http://202.157.76.21:6300/php7.3/maidmatchadmin/api";
// export const API_URL = "http://202.157.76.21:8001/admin/staging/api";
// export const API_URL = "http://202.157.76.21:8001/admin/qa/api";
// export const API_URL = "http://202.157.76.21:8001/admin/development/api";
// export const API_URL = "http://192.168.0.116:8888/maidmatch-admin/api";
//export const API_URL = "http://192.168.0.80/maid-match-admin/api";
export const APP_URL = process.env.REACT_APP_APP_URL;
export const API_URL = process.env.REACT_APP_APP_URL;
export const PUBLIC_IP_API_URL = process.env.REACT_APP_PUBLIC_IP_API_URL;
export const SETTINGS_API_URL = process.env.REACT_APP_SETTINGS_API_URL + '/api';
export const SETTINGS_SOCKET_URL = process.env.REACT_APP_SETTINGS_API_URL;
export const HRMS_API_URL = process.env.REACT_APP_HRMS_API_URL;
export const API_CHAT_URL = process.env.REACT_APP_CHAT_URL;
export const AWS_URL = process.env.REACT_APP_AWS_URL;
export const AWS_S3_PATH = process.env.AWS_S3_PATH;
export const REACT_APP_CONTRACT_API_URL = process.env.REACT_APP_CONTRACT_API_URL;
export const REACT_APP_PROCESSING_API_URL = process.env.REACT_APP_PROCESSING_API_URL;
export const REACT_APP_X_API_KEY = process.env.REACT_APP_X_API_KEY;
export const REACT_APP_AL_X_API_KEY = process.env.REACT_APP_AL_X_API_KEY;
export const REACT_APP_SCHEDULER_URL = process.env.REACT_APP_SCHEDULER_URL;
export const REACT_APP_REMOVE_BG_API_URL = process.env.REACT_APP_REMOVE_BG_API_URL;
export const REACT_APP_PDF_URL = process.env.REACT_APP_PDF_URL;
export const REACT_APP_INSURANCE_API_URL = process.env.REACT_APP_INSURANCE_API_URL;
export const HOST_TYPE = process.env.REACT_APP_HOST_TYPE;
export const CONVERSION_API_KEY = process.env.REACT_APP_CONVERSION_API_KEY;
export const REACT_WORKER_VIEW_URL = process.env.REACT_WORKER_VIEW_URL || "https://maidmatch.ai/job-stage-details";
export const REACT_JOB_VIEW_URL = process.env.REACT_JOB_VIEW_URL || "https://maidmatch.ai/job-details";
export const REACT_APP_PROMPT_AI_COPYWRITER_URL = process.env.REACT_APP_PROMPT_AI_COPYWRITER_URL || "https://aicopywriter.maidmatch.ai";
// export const API_URL = "https://staging.maidmatcher.com/admin/api";
